import { CSSProperties, FC } from 'react'
import { Tooltip } from '@arco-design/web-react'
import flags from '@/utils/regionFlags'
import _ from 'lodash'
import styles from './index.module.less'

type Props = {
  size?: number
  region?: {
    id: string
    name?: string
    key?: string
  }
  style?: CSSProperties
  shape?: 'circle' | 'square'
}

const FlagIcon: FC<Props> = (props) => {
  const { region, size = 16, shape, style, ...rest } = props

  if (region?.id === '') {
    const FlagModule = flags['GLOBAL']
    return (
      <div className={styles.flagWarp} style={{ boxShadow: '0 0 8px #ccc' }}>
        <FlagModule className={styles.flag} size={34} />
      </div>
    )
  }

  if (!region) {
    return null
  }

  if (!_.has(flags, region.id)) {
    return null
  }

  const FlagModule = flags[region.id]

  if (shape === 'circle') {
    return (
      <div className={styles.flagWarp} style={{ boxShadow: '0 0 8px #ccc' }}>
        <FlagModule className={styles.flag} width={34} />
      </div>
    )
  }

  return (
    <Tooltip content={region.name}>
      <FlagModule
        width={size}
        style={{ boxShadow: '0 0 8px #ccc', lineHeight: 1, display: 'inline-block', ...style }}
        {...rest}
      />
    </Tooltip>
  )
}

export default FlagIcon
